import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.998 1.99561L22.998 3.09561V7.90558L20.0663 8.19876L21.0737 22.0006H13.9122L15.0077 8.71261L11.998 9L9.08393 8.71417L10.0755 22.0006H2.92239L3.92983 8.19876L0.998047 7.90558V3.09561L11.998 1.99561ZM5.92062 8.39784L5.0737 20.0006H7.92064L7.06329 8.5121L5.92062 8.39784ZM17.0312 8.51068L16.0839 20.0006H18.9224L18.0757 8.4007C17.7242 8.4376 17.3788 8.47436 17.0312 8.51068Z"}}]};

const ShimenFilled = Vue.extend<IconProps>({
  name: 'ShimenFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'shimen-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ShimenFilled;
